import { RenderHtml, ScrollView } from '@bonanza-social/moonlight';
import { selectReferrerPromo } from '@bonanza-social/promos';
import { useSelector } from '@bonanza-social/toolkit/state';

function Terms() {
  const referrerPromo = useSelector(selectReferrerPromo);

  if (!referrerPromo?.termsAndConditions) return null;

  return (
    <ScrollView
      contentContainerStyle={{
        paddingBottom: {
          mobile: undefined,
          tablet: 'space-2000',
          desktop: 'space-2000',
        },
        maxWidth: {
          mobile: undefined,
          tablet: 650,
          desktop: 650,
        },
        marginHorizontal: {
          mobile: undefined,
          tablet: 'auto',
          desktop: 'auto',
        },
      }}
      showsVerticalScrollIndicator={false}
    >
      <RenderHtml html={referrerPromo.termsAndConditions} variant="body-m" />
    </ScrollView>
  );
}

export default Terms;
